<template>
	<Layout>
		<Sider collapsible v-model="isCollapsed" width="200" :collapsed-width="64" style="text-align: left;">
			<Menu ref="side_menu" :active-name="currentPath" theme="dark" width="auto" :open-names="openNames"
				:class="menuitemClasses">
				<div v-bind:key="itemIndex" v-for="(item, itemIndex) in MenuList">
					<Submenu v-bind:name="itemIndex" v-if="item.children.length > 0">
						<template slot="title">
							<svg v-if="item.icon" aria-hidden="true" :class="chooseStyle">
								<use :xlink:href="item.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
							</svg>
							<span>{{item.title}}</span>
						</template>
						<router-link v-bind:key="itemIndex2" v-for="(item2,itemIndex2) in item.children"
							v-bind:to="item.path+'/'+item2.path">
							<MenuItem v-bind:name="item.path+'/'+item2.path">
							<!-- <svg aria-hidden="true" :class="chooseStyle">
								<use :xlink:href="item2.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
							</svg> -->
							<span>{{item2.title}}</span>
							</MenuItem>
						</router-link>
					</Submenu>
					<Submenu v-else v-bind:name="itemIndex">
						<template slot="title">
							<svg v-if="item.icon" aria-hidden="true" :class="chooseStyle">
								<use :xlink:href="item.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
							</svg>
							<span>{{item.title}}</span>
						</template>
						<router-link v-bind:key="itemIndex" v-bind:to="item.path + item.path + 's'">
							<MenuItem v-bind:name="item.path">
							<!-- <svg aria-hidden="true" :class="chooseStyle">
								<use :xlink:href="item.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
							</svg> -->
							<span>{{item.title}}</span>
							</MenuItem>
						</router-link>
					</Submenu>
				</div>
			</Menu>
		</Sider>
		<Layout :style="{padding: '0 10px',height:'100%'}">
			<Content :style="{padding: '0px',background: '#F1F4F5'}">
				<MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread>
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</Content>
		</Layout>
	</Layout>
</template>

<script>
	import {
		mapState,
	} from 'vuex'
	export default {
		//props:['MenuList'],
		data() {
			return {
				MenuList: [],
				Menu: [],
				isCollapsed: false,
				openNames: [0],
				activeName: "0-0",
				BreadcrumbList: [],
			};
		},
		computed: {
			
			currentPath: function() {
				//console.log(this.$route.path.split('/')[1] )
				console.log(2323232323232)
				console.log(this.$route.path.split('/'))
				return '/' + this.$route.path.split('/')[1] + '/' + this.$route.path.split('/')[2]
			},
		
			...mapState({
				silderMethod: 'silderMethod',
			}),
			menuitemClasses: function() {
				return [
					'menu-item',
					this.isCollapsed ? 'collapsed-menu' : ''
				]
			},
			chooseStyle: function() {
				const _this = this;
				if (_this.isCollapsed) {
					return "icon closeStyle"
				} else {
					return "icon openStyle"
				}
			}
		},
		//监听地址栏变化，菜单变动
		watch: {
			$route(to, from) {
				const path = to.path.split('/');
				this.getSiderMenus(path);
			},
			activeName() {
				this.$nextTick(() => {
					this.$refs.side_menu.updateOpened();
					this.$refs.side_menu.updateActiveName();
				})
			}
		},
		//首次加载不触发 watch 挂载时主动查发一次
		created: function() {
			this.Menu = this.$store.state.silderMethod
			const path = this.$route.path.split('/');
			this.getSiderMenus(path);
		},
		methods: {
			getSiderMenus(path) {
				console.log("菜单变动");
				this.MenuList = [];
				let topName = '';
				this.BreadcrumbList = [];
				for (let i = 0; i < this.Menu.length; i++) {
					if (this.Menu[i].path == "/" + path[1]) {
						topName = this.Menu[i].topName;
						// this.MenuList.push(this.Menu[i]);
						this.BreadcrumbList.push(topName);
						this.BreadcrumbList.push(this.Menu[i].title);
					}
				}
				for (let i = 0; i < this.Menu.length; i++) {
					if (this.Menu[i].topName == topName) {
						this.MenuList.push(this.Menu[i]);
						for (let c = 0; c < this.Menu[i].children.length; c++) {
							if (this.Menu[i].children[c].path == path[2]) {
								this.BreadcrumbList.push(this.Menu[i].children[c].title);
							}
						}
					}
				}
				if (!this.MenuList || this.MenuList.length < 1) return;
				this.openNames = this.MenuList.map((obj, index) => index);
				this.activeName = this.MenuList[0].path + "/" + this.MenuList[0].children[0].path;
				// this.BreadcrumbList = [this.MenuList[0].title, this.MenuList[0].children[0].title];
				console.log(this.activeName, this.openNames);
				console.log("菜单变动结束");
			},
		}
	}
</script>

<style>
	.layout-con {
		height: 100%;
		width: 100%;
	}

	.menu-item span {
		display: inline-block;
		overflow: hidden;
		/* width: 80px; */
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: bottom;
		transition: width 0.2s ease 0.2s;
	}

	.menu-item i {
		transform: translateX(0px);
		transition: font-size 0.2s ease, transform 0.2s ease;
		vertical-align: middle;
		font-size: 1.25rem;
	}

	.collapsed-menu span {
		width: 0px !important;
		transition: width 0.2s ease;
	}

	.collapsed-menu .ivu-menu-item {
		padding: 14px 9px !important;
	}

	.collapsed-menu i {
		transform: translateX(5px);
		transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
		vertical-align: middle;
		font-size: 1.25rem;
	}

	.ant-layout-sider-trigger {
		display: block !important;
	}
	
	:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened) {
		background: #303078aa !important;
	}

	.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
		content: "";
		display: block;
		width: 2px;
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		background: #3098ff;
	}

	.closeStyle {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}

	.openStyle {
		width: 18px;
		height: 18px;
		vertical-align: middle;
		margin-right: 5px;
	}
	
	.ivu-layout-sider-collapsed .ivu-menu-submenu-title-icon {
		display: none;
	}

	.menu-item span {
		/* width: 80px; */
	}
	
	.ivu-layout-sider-collapsed .ivu-menu-vertical .ivu-menu-submenu-title {
		padding: 14px 20px;
	}
</style>